import { Result } from './model';
export function asChecked(sanitizer, predicate, expected) {
    if (expected === void 0) { expected = 'custom logic'; }
    return function (value, path) {
        var result = sanitizer(value, path);
        if (Result.isOk(result) && !predicate(result.ok)) {
            return Result.error([{ path: path, expected: expected }]);
        }
        return result;
    };
}
